import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  TemplateRef,
  ChangeDetectionStrategy
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { checkboxProps } from './checkbox.utils';
@Component({
  selector: 'cohrex-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class CheckboxComponent implements OnInit, OnChanges {
  props: string = '';

  private _color?: string = 'primary';
  @Input()
  set color(value: string | undefined) {
    this._color = value;
  }
  get color(): string | undefined {
    return this._color;
  }

  private _checked?: boolean = false;
  @Input()
  set checked(value: boolean | undefined) {
    this._checked = value;
  }
  get checked(): boolean | undefined {
    return this._checked;
  }

  private _disabled?: boolean = false;
  @Input()
  set disabled(value: boolean | undefined) {
    this._disabled = value;
  }
  get disabled(): boolean | undefined {
    return this._disabled;
  }

  private _helperText?: string = '';
  @Input()
  set helperText(value: string | undefined) {
    this._helperText = value;
  }
  get helperText(): string | undefined {
    return this._helperText;
  }

  private _controlName?: string = '';
  @Input()
  set controlName(value: string | undefined) {
    this._controlName = value;
  }
  get controlName(): string | undefined {
    return this._controlName;
  }

  private _isError?: boolean = false;
  @Input()
  set isError(value: boolean | undefined) {
    this._isError = value;
  }
  get isError(): boolean | undefined {
    return this._isError;
  }

  private _form?: FormGroup;
  @Input()
  set form(value: FormGroup | undefined) {
    this._form = value;
  }
  get form(): FormGroup | undefined {
    return this._form;
  }

  @Input() label: string | TemplateRef<unknown> = '';
  @Input() value: string = '';
  @Input() controlArray: string = '';
  isStringLabel: boolean = true;

  @Output()
  selected = new EventEmitter<Event>();

  ngOnInit(): void {
    this.isStringLabel = typeof this.label === 'string';
    this.initProps();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.initProps();
  }

  initProps() {
    this.props = checkboxProps({
      color: this.color,
      checked: this.checked,
      disabled: this.disabled
    })?.toString();
  }

  handleCheckboxSelected(event: Event) {
    this.selected.emit(event);
  }
}
